// src/App.js
import React, { Component } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { initTranslation } from '../assets/i18n';
import { interceptorToken } from '../api/utils';
import '../App.css';
import Providers from './Providers';
import { ProfileProvider } from '../context';
import ReactGA from "react-ga4";
import { configureToken } from 'api';

// Initialize Google Analytics
if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
}

const queryClient = new QueryClient();

class App extends Component {
  constructor(props) {
    super(props);
    const token = localStorage.getItem('token');
    if (token) {
      configureToken(token);
    }
    interceptorToken();
    initTranslation();
  }

  render() {
    return (
      <ProfileProvider>
        <QueryClientProvider client={queryClient}>
          <Providers />
        </QueryClientProvider>
      </ProfileProvider>
    );
  }
}

export default App;